import { render } from "./Vouchers.vue?vue&type=template&id=fc7e036e&scoped=true"
import script from "./Vouchers.vue?vue&type=script&lang=js"
export * from "./Vouchers.vue?vue&type=script&lang=js"

import "./Vouchers.vue?vue&type=style&index=0&id=fc7e036e&scoped=true&lang=scss"

import exportComponent from "/builds/swift-dental/my-swift-dental/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc7e036e"]])

export default __exports__